export function resetMessages() {
    return {
        type: "RESET_ERROR_MESSAGES",
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/messages.js